import {BASE_URL} from "@/utils/config";

export const generateExcelFile = async (axiosInstance, data) => {
	try {
		const response = await axiosInstance.post(`${BASE_URL}/admin/file/generate-excel`, data, {
			responseType: 'blob',
		});

		if (response.status === 200) {
			return {
				success: true,
				data: response.data,
			}
		} else {
			return response.data;
		}
	} catch (error) {
		console.log("(admin/eventApi.js) Error while fetching all events: ", error);
	}
}
